export const ARMY_NUMBERS: number[] = Array.from({ length: 19 }, (_, i) => i + 1)
export const NAVY_NUMBERS: number[] = Array.from({ length: 38 - 20 + 1 }, (_, i) => 20 + i)

export const mapInsigniaToRank = (ordinal: number): string => {
  switch (ordinal) {
    // Maavoimat
    // Miehistö
    case 1:
      return 'Sotamies, Aliupseerioppilas'
    case 2:
      return 'Korpraali'
    // Aliupseerit
    case 3:
      return 'Alikersantti'
    case 4:
      return 'Kersantti'
    case 5:
      return 'Ylikersantti'
    case 6:
      return 'Vääpeli'
    case 7:
      return 'Ylivääpeli'
    case 8:
      return 'Sotilasmestari'
    // Upseerit
    case 9:
      return 'Vänrikki'
    case 10:
      return 'Luutnantti'
    case 11:
      return 'Yliluutnantti'
    case 12:
      return 'Kapteeni'
    case 13:
      return 'Majuri'
    case 14:
      return 'Everstiluutnantti'
    case 15:
      return 'Eversti'
    case 16:
      return 'Prikaatikenraali'
    case 17:
      return 'Kenraalimajuri'
    case 18:
      return 'Kenraaliluutnantti'
    case 19:
      return 'Kenraali'
    // Merivoimat
    // Miehistö
    case 20:
      return 'Matruusi'
    case 21:
      return 'Ylimatruusi'
    // Aliupseerit
    case 22:
      return 'Alikersantti'
    case 23:
      return 'Kersantti'
    case 24:
      return 'Ylikersantti'
    case 25:
      return 'Pursimies'
    case 26:
      return 'Ylipursimies'
    case 27:
      return 'Sotilasmestari'
    // Upseerit
    case 28:
      return 'Aliluutnantti'
    case 29:
      return 'Luutnantti'
    case 30:
      return 'Yliluutnantti'
    case 31:
      return 'Kapteeniluutnantti'
    case 32:
      return 'Komentajakapteeni'
    case 33:
      return 'Komentaja'
    // Kenraalikunta / lippu-upseerit
    case 34:
      return 'Kommodori'
    case 35:
      return 'Lippueamiraali'
    case 36:
      return 'Kontra-amiraali'
    case 37:
      return 'Vara-amiraali'
    case 38:
      return 'Amiraali'
    default:
      return 'Aamukasa'
  }
}
